import React, { useState } from 'react';

const LeadMagnet = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Criar mensagem personalizada para WhatsApp
    const message = `Olá, gostaria de receber o e-book "Os 7 Padrões Emocionais que Sabotam Relacionamentos".

Meus dados:
Nome: ${formData.name}
E-mail: ${formData.email}
WhatsApp: ${formData.whatsapp}`;

    // Redirecionar para WhatsApp
    const phoneNumber = "5537998630380";
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Descubra os Padrões que Sabotam seus Relacionamentos
            </h2>
            <p className="text-xl mb-8 text-gray-300">
              E-book exclusivo: "Os 7 Padrões Emocionais que Sabotam Relacionamentos"
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="bg-white p-8 rounded-lg shadow-2xl">
                <img 
                  src="/images/ebook-cover-placeholder.jpg" 
                  alt="E-book Os 7 Padrões Emocionais" 
                  className="w-full h-auto mb-6 rounded"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
                <div className="text-black">
                  <h3 className="text-2xl font-bold mb-4 text-center">
                    Os 7 Padrões Emocionais que Sabotam Relacionamentos
                  </h3>
                  <p className="text-center text-gray-600 mb-4">
                    Por Kelton Oliveira
                  </p>
                  <div className="space-y-3 text-sm">
                    <div className="flex items-center">
                      <span className="text-red-600 mr-2">✓</span>
                      <span>Identifique padrões inconscientes destrutivos</span>
                    </div>
                    <div className="flex items-center">
                      <span className="text-red-600 mr-2">✓</span>
                      <span>Compreenda as raízes psíquicas dos sabotagens</span>
                    </div>
                    <div className="flex items-center">
                      <span className="text-red-600 mr-2">✓</span>
                      <span>Reflexões para autoconhecimento profundo</span>
                    </div>
                    <div className="flex items-center">
                      <span className="text-red-600 mr-2">✓</span>
                      <span>Baseado em +2 mil atendimentos realizados</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold mb-6">
                Receba gratuitamente este material exclusivo
              </h3>
              <p className="text-gray-300 mb-8">
                Um guia profundo para identificar e compreender os padrões emocionais inconscientes que impedem relacionamentos saudáveis e duradouros.
              </p>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Seu nome completo"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-red-500 transition-colors"
                  />
                </div>
                
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Seu melhor e-mail"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-red-500 transition-colors"
                  />
                </div>
                
                <div>
                  <input
                    type="tel"
                    name="whatsapp"
                    placeholder="Seu WhatsApp (com DDD)"
                    value={formData.whatsapp}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-red-500 transition-colors"
                  />
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-lg transition-colors duration-300 text-lg"
                >
                  QUERO RECEBER O E-BOOK GRATUITAMENTE
                </button>
              </form>
              
              <p className="text-sm text-gray-400 mt-4 text-center">
                Seus dados estão seguros. Não enviamos spam.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadMagnet;

